// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"2":"25f4e7734aa321b8","144":"fff3063a59414f03","187":"b9bb09b514960eef","348":"cbd1619e33aaeac9","364":"ca3dad523c1cb5c7","373":"f845b2f4704c0bd7","582":"4b790813c93ba025","727":"dbdb2536eae8cab6","925":"8d55bbee3a80f28b","947":"38a494106c454a09"}[chunkId] + ".js";
};